import * as THREE from 'three';
import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js';
import { StateManager } from "./statemanager";
import { State } from "./state";
import { MapManager } from "../maps/mapmanager";

export class MovGenState extends State {
    world: any;
    controls: any;

    constructor() {
        super();
        this.world = null;
    }

    async prepare(): Promise<void> {
        // No preparation needed for movement generation state
    }

    genMovData() {
        const bounds = [5600, 4960, 5760, 5280];
        console.log("Generating move data.");
        this.world.rootObj.updateMatrixWorld();
        const sampleOne = (x: any, y: any, u: any, v: any) => {
            const highZ = this.world.findHighPoint(x + u, y + v);
            return highZ;
        };
        for (let ix = bounds[0] / 10; ix < bounds[2] / 10; ++ix) {
            for (let iy = bounds[1] / 10; iy < bounds[3] / 10; ++iy) {
                const bX = ix * 10 + 5;
                const bY = iy * 10 + 5;
                const samples = [];
                for (let jx = -5; jx <= 5; jx += 2) {
                    for (let jy = -5; jy <= 5; jy += 2) {
                        samples.push(sampleOne(bX, bY, jx, jy));
                    }
                }
                /*
          samples.push(sampleOne(bX, bY, -2.5, -2.5));
          samples.push(sampleOne(bX, bY, 2.5, -2.5));
          samples.push(sampleOne(bX, bY, -2.5, 2.5));
          samples.push(sampleOne(bX, bY, 2.5, 2.5));
          */
                let avgHeight = 0;
                for (let i = 0; i < samples.length; ++i) {
                    avgHeight += samples[i];
                }
                avgHeight /= samples.length;
                let canMove = true;
                for (let i = 0; i < samples.length; ++i) {
                    if (Math.abs(avgHeight - samples[i]) > 5) {
                        canMove = false;
                    }
                }
                if (canMove) {
                    const ah = new THREE.AxesHelper(1);
                    ah.position.set(bX, bY, avgHeight + 2);
                    scene.add(ah);
                }
            }
        }
        console.log("Generated move data.");
    }

    enter() {
        const wm = new MapManager();
        wm.rootObj.position.set(5200, 5200, 0);
        wm.setMap(22, () => {
            console.log("Map Ready");
            wm.setViewerInfo(null, () => {
                this.genMovData();
            });
        });
        this.world = wm;
        scene.add(wm.rootObj);
        let controls = new FlyControls(camera, renderer.domElement);
        controls.movementSpeed = 100;
        controls.rollSpeed = Math.PI / 24;
        controls.dragToLook = false; // Any mouse button to rotate
        this.controls = controls;
        camera.position.x = 5552;
        camera.position.y = 5159;
        camera.position.z = 180;
    }

    leave() {}

    update(delta: any) {
        this.controls.update(delta);
    }
}

/**
 * @constructor
 */

StateManager.register("movgen", MovGenState);
